import React from 'react';
import { FormattedMessage } from 'react-intl';
import Toggle from '../../toggle';
import Tooltip from '../../tooltip';
import styles from './form-components.module.scss';

interface ToggleFieldProps {
  label?: string | React.ReactNode;
  tooltip?: string;
  tooltipTestId?: string;
  checked: boolean;
  onChange: (checked: boolean) => void;
  disabled?: boolean;
  messageId?: string;
  defaultMessage?: string;
}

/**
 * ToggleField - Reusable toggle field with label and optional tooltip
 * Provides consistent styling for all toggle fields across modals
 */
export const ToggleField: React.FC<ToggleFieldProps> = ({
  label,
  tooltip,
  tooltipTestId,
  checked,
  onChange,
  disabled = false,
  messageId,
  defaultMessage,
}) => {
  return (
    <div className={styles.toggleField}>
      <span className={styles.toggleField__label}>
        {messageId ? (
          <FormattedMessage id={messageId} defaultMessage={defaultMessage || label as string} />
        ) : (
          label
        )}
        {tooltip && (
          <span className={styles.toggleField__tooltip}>
            <Tooltip testId={tooltipTestId}>
              {tooltip}
            </Tooltip>
          </span>
        )}
      </span>
      <Toggle
        checked={checked}
        disabled={disabled}
        isCustomDisabledState={false}
        onChange={() => onChange(!checked)}
      />
    </div>
  );
};

export default ToggleField;